import SlideItem from "js/editor/components/slideItemView";

/*
  the view shall receive
  model<slide.model>,
  slideIndex <slide index>,
  player
*/

export const PlayerThumbnailView = SlideItem.extend({
    events: {
        click: "selectSlide"
    },
    selectSlide(event) {
        if (this.options.slideIndex != this.options.player.currentSlideIndex) {
            this.options.player.prepareSlideToPlay(this.options.slideIndex);
            this.options.player.goToSlide(this.options.slideIndex, true, true);
        }
        this.options.player.hideSlideGrid();
        this.listenTo(this.options.player, "update", player => {
            console.log("UPDATE");
        });
    },
    highlight: function() {
        if (this.options.slideIndex != this.options.player.currentSlideIndex) {
            this.$el.removeClass("selected");
        } else {
            this.$el.addClass("selected");
        }
    }
});
